// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-featured-clips-widget__container {
    background: var(--white-color);
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: var(--space-and-half);
}

.home-featured-clips-widget__container .baloa-normal-medium {
    color: var(--primary-very-dark-color);
}

.home-featured-clips-widget__clips-container {
    display: flex;
    align-items: center;
    margin-top: 14px;
    gap: 14px;
    position: relative;
    overflow-x: hidden;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    overflow-y: hidden;
}

.home-featured-clips-widget__scroll-clips-container {
    display: flex;
    align-items: center;
    
    gap: 14px;
    /* position: relative;
    overflow-x: hidden;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    overflow-y: hidden; */
}

.home-featured-clips-widget__clip-link {
    position: relative;
    cursor: pointer;
}

/* .home-featured-clips-widget__clip-link:last-child {
    margin-right: 20px;
} */

.home-featured-clips-widget__clip-link img {
    border-radius: 8px;
    width: 176px;
    height: 288px;
    object-fit: cover;
}

.home-featured-clips-widget__clip-link__author-photo  {
    position: absolute;
    top: 6px;
    left: 7px;
}

.home-featured-clips-widget__clip-link__author-photo .hubicon-default_pp {
    font-size: 40px;
}

.home-featured-clips-widget__clip-link__author-name {
    position: absolute;
    bottom: 13px;
    left: 7px;
    display: -webkit-box;             /* Usar el modelo de caja flexible para webkit */
    -webkit-box-orient: vertical;     /* Orientar la caja en modo vertical */
    -webkit-line-clamp: 2;            /* Mostrar un máximo de 2 líneas */
    overflow: hidden;
    text-overflow: ellipsis;    
    max-height: calc(calc(var(--space) + var(--space-quarter))*2);
    height: calc(calc(var(--space) + var(--space-quarter))*2);
    margin: 0; 
}

.home-featured-clips-widget__clip-link__author-name.baloa-names{
    color: var(--white-color);
}

.home-featured-clips-widget__clip-link__author-photo img{
    width: 40px;
    height: 40px;
    border: 1px solid var(--white-color);
    border-radius: 50%;
}

.home-featured-clips-widget__baloer-message {
    margin-top: 14px;
    color: var(--primary-very-dark-color);
    display: flex;
    align-items: center;
    gap: 20px;
    justify-content: space-between;
}

.home-featured-clips-widget__baloer-message.new-user {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}

.home-featured-clips-widget__baloer-message .baloa-normal-medium {
    color: var(--primary-very-dark-color);
    margin-right: 4px;
}

.home-featured-clips-widget__baloer-message .baloa-names {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.home-featured-clips-widget__baloer-message .hubicon-award_star {
    font-size: 16px;
}

.home-featured-clips-widget__button.button {
    background-color: #EAF7F0;
    padding: 8px 16px;
    text-wrap: nowrap;
    font-size: 17px;
}

.home-featured-clips-widget__button.button.primary-button {
    background-color: var(--new-green-color);
} 

.home-featured-clips-widget__button.button:hover {
    color: var(--new-green-color);
}

.home-featured-clips-widget__button.button.primary-button:hover {
    color: var(--white-color);
}

.home-featured-clips-widget__button.secondary-button.xs:hover {
    color: var(--new-green-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */    

    .home-featured-clips-widget__clip-link img {
        width: 111px;
        height: 191px;
    }

    .home-featured-clips-widget__clip-link__author-photo img {
        width: 27px;
        height: 27px;
    }

    .home-featured-clips-widget__scroll-clips-container {
        gap: 8px;
    }

    .home-featured-clips-widget__clips-container {
        overflow-x: scroll;
    }

    .home-featured-clips-widget__container {
        border-radius: 0;
        /* margin-top: 68px; */
        margin-bottom: 0;
    }

    .home-featured-clips-widget__container:first-child{
        margin-top: 68px;
    }

    .home-featured-clips-widget__button.button {
        font-size: 13px;
        padding: 8px 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/home/components/home-featured-clips/HomeFeaturedClipsWidgetComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;;IAEnB,SAAS;IACT;;;;yBAIqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;GAEG;;AAEH;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,oBAAoB,cAAc,gDAAgD;IAClF,4BAA4B,MAAM,sCAAsC;IACxE,qBAAqB,aAAa,kCAAkC;IACpE,gBAAgB;IAChB,uBAAuB;IACvB,6DAA6D;IAC7D,yDAAyD;IACzD,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ","sourcesContent":[".home-featured-clips-widget__container {\n    background: var(--white-color);\n    border-radius: 8px;\n    padding: 12px 16px;\n    margin-bottom: var(--space-and-half);\n}\n\n.home-featured-clips-widget__container .baloa-normal-medium {\n    color: var(--primary-very-dark-color);\n}\n\n.home-featured-clips-widget__clips-container {\n    display: flex;\n    align-items: center;\n    margin-top: 14px;\n    gap: 14px;\n    position: relative;\n    overflow-x: hidden;\n    scroll-snap-type: x mandatory;\n    scroll-behavior: smooth;\n    overflow-y: hidden;\n}\n\n.home-featured-clips-widget__scroll-clips-container {\n    display: flex;\n    align-items: center;\n    \n    gap: 14px;\n    /* position: relative;\n    overflow-x: hidden;\n    scroll-snap-type: x mandatory;\n    scroll-behavior: smooth;\n    overflow-y: hidden; */\n}\n\n.home-featured-clips-widget__clip-link {\n    position: relative;\n    cursor: pointer;\n}\n\n/* .home-featured-clips-widget__clip-link:last-child {\n    margin-right: 20px;\n} */\n\n.home-featured-clips-widget__clip-link img {\n    border-radius: 8px;\n    width: 176px;\n    height: 288px;\n    object-fit: cover;\n}\n\n.home-featured-clips-widget__clip-link__author-photo  {\n    position: absolute;\n    top: 6px;\n    left: 7px;\n}\n\n.home-featured-clips-widget__clip-link__author-photo .hubicon-default_pp {\n    font-size: 40px;\n}\n\n.home-featured-clips-widget__clip-link__author-name {\n    position: absolute;\n    bottom: 13px;\n    left: 7px;\n    display: -webkit-box;             /* Usar el modelo de caja flexible para webkit */\n    -webkit-box-orient: vertical;     /* Orientar la caja en modo vertical */\n    -webkit-line-clamp: 2;            /* Mostrar un máximo de 2 líneas */\n    overflow: hidden;\n    text-overflow: ellipsis;    \n    max-height: calc(calc(var(--space) + var(--space-quarter))*2);\n    height: calc(calc(var(--space) + var(--space-quarter))*2);\n    margin: 0; \n}\n\n.home-featured-clips-widget__clip-link__author-name.baloa-names{\n    color: var(--white-color);\n}\n\n.home-featured-clips-widget__clip-link__author-photo img{\n    width: 40px;\n    height: 40px;\n    border: 1px solid var(--white-color);\n    border-radius: 50%;\n}\n\n.home-featured-clips-widget__baloer-message {\n    margin-top: 14px;\n    color: var(--primary-very-dark-color);\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    justify-content: space-between;\n}\n\n.home-featured-clips-widget__baloer-message.new-user {\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n}\n\n.home-featured-clips-widget__baloer-message .baloa-normal-medium {\n    color: var(--primary-very-dark-color);\n    margin-right: 4px;\n}\n\n.home-featured-clips-widget__baloer-message .baloa-names {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.home-featured-clips-widget__baloer-message .hubicon-award_star {\n    font-size: 16px;\n}\n\n.home-featured-clips-widget__button.button {\n    background-color: #EAF7F0;\n    padding: 8px 16px;\n    text-wrap: nowrap;\n    font-size: 17px;\n}\n\n.home-featured-clips-widget__button.button.primary-button {\n    background-color: var(--new-green-color);\n} \n\n.home-featured-clips-widget__button.button:hover {\n    color: var(--new-green-color);\n}\n\n.home-featured-clips-widget__button.button.primary-button:hover {\n    color: var(--white-color);\n}\n\n.home-featured-clips-widget__button.secondary-button.xs:hover {\n    color: var(--new-green-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */    \n\n    .home-featured-clips-widget__clip-link img {\n        width: 111px;\n        height: 191px;\n    }\n\n    .home-featured-clips-widget__clip-link__author-photo img {\n        width: 27px;\n        height: 27px;\n    }\n\n    .home-featured-clips-widget__scroll-clips-container {\n        gap: 8px;\n    }\n\n    .home-featured-clips-widget__clips-container {\n        overflow-x: scroll;\n    }\n\n    .home-featured-clips-widget__container {\n        border-radius: 0;\n        /* margin-top: 68px; */\n        margin-bottom: 0;\n    }\n\n    .home-featured-clips-widget__container:first-child{\n        margin-top: 68px;\n    }\n\n    .home-featured-clips-widget__button.button {\n        font-size: 13px;\n        padding: 8px 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
